module.exports = __webpack_public_path__ + "static/img/background.7e7ab0b9.svg";